// Bibliothek der Runs (M9, Fabi 29.10.2026; Erste Fassung, Runde 5): Jeder Run, der zu Ende geht, kommt mit seinem
// Logbuch-Satz in die Bibliothek im Browser-Speicher. Am Ende eines Runs und von der Startseite aus sieht man sie.
import { getSpecies } from '../content/index.ts';
import type { RunRecord } from '../sim/index.ts';

const KEY = 'fff.library.v1';
/** So viele Reisen hebt die Bibliothek auf [ZAHL?] */
const KEEP = 60;

export function loadLibrary(): RunRecord[] {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as RunRecord[]) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

function store(list: RunRecord[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(-KEEP)));
  } catch {
    // ohne Speicher gibt es die Bibliothek nur bis zum Neuladen
  }
}

/** Einen Run eintragen, wenn er noch nicht drinsteht; gibt die ganze Bibliothek zurück */
export function addToLibrary(rec: RunRecord): RunRecord[] {
  const list = loadLibrary();
  if (!list.some((r) => r.id === rec.id)) {
    list.push({ ...rec, date: rec.date || new Date().toLocaleDateString('de-DE') });
    store(list);
  }
  return list;
}

/** M9: Den Logbuch-Satz darf man ändern */
export function setLibraryLine(id: string, line: string): void {
  const list = loadLibrary();
  const r = list.find((x) => x.id === id);
  if (!r) return;
  r.line = line.trim().slice(0, 300);
  store(list);
}

const esc = (s: string) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]!);

/** Das Regal: die Reisen, die neueste oben; die gerade beendete ist hervorgehoben */
export function shelfHtml(list: RunRecord[], current?: string): string {
  if (!list.length) return '<p class="hint">Noch keine Reise in der Bibliothek.</p>';
  const rows = [...list]
    .reverse()
    .slice(0, 12)
    .map((r) => recordHtml(r, current))
    .join('');
  const more = list.length > 12 ? `<p class="hint">Dazu ${list.length - 12} ältere Reisen.</p>` : '';
  return `<ol class="shelf">${rows}</ol>${more}`;
}

/** Eine Reise der Bibliothek: wie sie ausging, der Satz aus dem Logbuch und wer dabei war */
export function recordHtml(r: RunRecord, current?: string, n?: number): string {
  const crew = r.crew.map((c) => `<span class="${c.gone ? 'gone' : ''}" title="${esc(`${speciesName(c.species)}, Level ${c.level}${c.gone ? ', nicht angekommen' : ''}`)}">${esc(c.name)}</span>`).join(', ');
  return `<li class="${r.id === current ? 'now' : ''}">
        <div class="shelf-head"><b>${n ? `Reise ${n}: ` : ''}${r.won ? 'Am Ziel' : `Bis Tag ${r.days}`}</b><small>${esc(r.date)} · ${r.fights} ${r.fights === 1 ? 'Kampf' : 'Kämpfe'} · ${r.farewells ? `${r.farewells} ${r.farewells === 1 ? 'Abschied' : 'Abschiede'}` : 'kein Abschied'}</small></div>
        <q>${esc(r.line)}</q>
        <div class="shelf-crew">${crew}</div>
      </li>`;
}

function speciesName(id: string): string {
  try {
    return getSpecies(id).name;
  } catch {
    return id;
  }
}
